module.exports = __webpack_public_path__ + "bb2.no2.1d8a0111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb2.no2.jpg
// module id = 7TtW
// module chunks = 0